import { useMemo, useState } from "react";
import {
 FiChevronDown,
 FiChevronLeft,
 FiChevronRight,
 FiGrid,
 FiImage,
 FiLogOut,
 FiPackage,
 FiShoppingBag,
} from "react-icons/fi";

const menuGroups = [
 { id: "main", label: "Main", icon: FiGrid, pages: ["dashboard"] },
 {
  id: "content",
  label: "Content",
  icon: FiImage,
  pages: [
   "sliders",
   "aboutSliders",
   "journeyImages",
   "communityImages",
   "customerFeedback",
   "scootyFeatures",
   "systemCertifications",
   "productCertifications",
  ],
 },
 { id: "catalogue", label: "Catalogue", icon: FiPackage, pages: ["categories", "products", "stock"] },
 { id: "sales", label: "Sales", icon: FiShoppingBag, pages: ["enquiries"] },
];

export default function Sidebar({
 activePage,
 setActivePage,
 user,
 logout,
 pages,
 collapsed,
 setCollapsed,
}) {
 const pageMap = useMemo(
  () => new Map(pages.map((page) => [page.id, page])),
  [pages],
 );
 const activeGroup = menuGroups.find((group) => group.pages.includes(activePage))?.id || "main";
 const [openGroups, setOpenGroups] = useState(() => {
  const saved = localStorage.getItem("mozoSidebarMenuGroups");
  return saved
   ? JSON.parse(saved)
   : { main: false, content: false, catalogue: true, sales: false };
 });

 function toggleGroup(groupId) {
  if (collapsed) return;
  setOpenGroups((current) => {
   const next = { ...current, [groupId]: !current[groupId] };
   localStorage.setItem("mozoSidebarMenuGroups", JSON.stringify(next));
   return next;
  });
 }

 return (
  <aside className={collapsed ? "sidebar collapsed" : "sidebar"}>
   <button
    className="sidebar-toggle"
    type="button"
    onClick={() => setCollapsed((current) => !current)}
    aria-label={collapsed ? "Expand sidebar" : "Collapse sidebar"}
   >
    {collapsed ? <FiChevronRight /> : <FiChevronLeft />}
   </button>

   <div className="brand">
    <img
     src="/favicon.ico"
     alt="Mozo Logo"
     style={{ width: "40px", height: "40px", objectFit: "contain" }}
    />
    <div>
     <strong>Mozo Admin</strong>
     <small>{user?.email}</small>
    </div>
   </div>

   <nav className="sidebar-menu">
    {menuGroups.map((group) => {
     const GroupIcon = group.icon;
     const isOpen = !collapsed && openGroups[group.id];
     const isActiveGroup = group.id === activeGroup;
     const visiblePages = group.pages.map((pageId) => pageMap.get(pageId)).filter(Boolean);

     return (
      <section className="menu-group" key={group.id}>
       <button
        className={isActiveGroup ? "menu-group-trigger active" : "menu-group-trigger"}
        type="button"
        onClick={() => toggleGroup(group.id)}
        aria-expanded={isOpen}
        title={group.label}
       >
        <GroupIcon />
        <span>{group.label}</span>
        <FiChevronDown className={isOpen ? "chevron open" : "chevron"} />
       </button>

       {isOpen ? (
        <div className="menu-group-items">
         {visiblePages.map((page) => {
          const Icon = page.icon;
          return (
           <button
            className={activePage === page.id ? "nav-link active" : "nav-link"}
            key={page.id}
            type="button"
            onClick={() => setActivePage(page.id)}
            title={page.label}
           >
            <Icon />
            <span>{page.label}</span>
           </button>
          );
         })}
        </div>
       ) : null}
      </section>
     );
    })}
   </nav>

   <button className="logout-button" type="button" onClick={logout}>
    <FiLogOut /> Logout
   </button>
  </aside>
 );
}
